import { render } from "./what-task.vue?vue&type=template&id=f30167a4&lang=pug"
import script from "./what-task.vue?vue&type=script&lang=js"
export * from "./what-task.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__